import get from 'lodash/get';

import { INSURANCE_FLOW_TYPE } from '../../../../../../constants/insurance-flow-type';
import { validateInsuranceFormFields } from '../../../../../../utils/manage-insurances/get-initial-insurance-form-values';

export const checkIsNeedToShowErrorMessage = ({
  flowType,
  insuranceData,
  hideInsuranceRelationFieldOrInfo,
  frozenAdditionalInsurancesListIds,
}) => {
  const insuranceId = get(insuranceData, 'id');

  if (
    ![
      INSURANCE_FLOW_TYPE.GET_CARE_FLOW,
      INSURANCE_FLOW_TYPE.PAPERWORK,
    ].includes(flowType)
  ) {
    return false;
  }

  const isAllRequiredFieldsFilled = validateInsuranceFormFields({
    formState: insuranceData,
    hideInsuranceRelationFieldOrInfo,
  });

  return (
    !isAllRequiredFieldsFilled &&
    (frozenAdditionalInsurancesListIds || []).includes(insuranceId)
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/InsuranceForm/components/AdditionalInsurancesSection/utils/check-is-need-to-show-error-message.js